<template>
  <div class="uk-card-small uk-card-default uk-margin-top uk-text-small">
    <div class="uk-card-header">
      <h3 class="uk-card-title">Loads</h3>
    </div>
    <div class="uk-card-body">
      <table class="uk-table uk-table-striped uk-table-small">
        <thead>
          <th>Quantity</th>
          <th>Package Type</th>
          <th>Is Hazmat</th>
          <th>Weight (lbs)</th>
          <th>Commodity Description</th>
          <th>NMFC No (LTL Only)</th>
          <th>Class (LTL Only)</th>
        </thead>
        <tbody v-if="container != null">
          <tr
            v-for="(freightContent, freightContentIdx) in container.freightContents"
            :key="freightContentIdx"
            >
            <td class="uk-padding-remove-left uk-padding-remove-right">
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                placeholder="Quantity"
                v-model="container.freightContents[freightContentIdx].quantity"
              />
            </td>

            <td class="uk-padding-remove-left uk-padding-remove-right">
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                placeholder="Package Type"
                v-model="container.freightContents[freightContentIdx].packingType"
              />
            </td>
            <td class="uk-padding-remove-left uk-padding-remove-right">
              <input
                type="checkbox"
                class="uk-checkbox"
                placeholder="Is Hazmat"
                v-model="container.freightContents[freightContentIdx].isHazmat"
              />
            </td>
            <td class="uk-padding-remove-left uk-padding-remove-right">
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                v-model="container.freightContents[freightContentIdx].weight"
                placeholder="Weight (lbs)"
              />
            </td>
            <td class="uk-padding-remove-left uk-padding-remove-right">
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-medium"
                v-model="container.freightContents[freightContentIdx].description"
                placeholder="Commodity Description"
              />
            </td>
            <td class="uk-padding-remove-left uk-padding-remove-right">
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                v-model="container.freightContents[freightContentIdx].nmfcNumber"
                placeholder="NMFC No"
              />
            </td>
            <td class="uk-padding-remove-left uk-padding-remove-right">
              <input
                type="text"
                class="uk-input uk-form-small uk-form-width-small"
                v-model="container.freightContents[freightContentIdx].nmfcClass"
                placeholder="NMFC Class"
              />
            </td>
            <td uk-tooltip="Remove container">
              <span @click="removeFreightContents(0, freightContentIdx)" uk-icon="minus-circle"></span>
            </td>
          </tr>
        </tbody>
        <tbody class="uk-margin" v-if="!isDropAndHook">
          <button @click="addFreightContents(0)" class="uk-button uk-button-secondary">
            <span uk-icon="plus-circle"></span> Load Item
          </button>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ORDER_TYPE } from '../../../types';

export default defineComponent({
  props: {
    orderData: Object,
    activeContainersWithoutOrder: Array,
  },
  computed: {
    container() {
      return (this as any).orderData.containers[0];
    },
    isDropAndHook(): boolean {
      return (this as any).orderData.isDropAndHook;
    },
  },
  methods: {
    strForContainerLoadType(loadType: string): string {
      if (loadType === 'EmptyOut') return 'Empty Out';
      if (loadType === 'EmptyIn') return 'Empty In';
      if (loadType === 'FullOut') return 'Full Out';
      else return 'Full In';
    },
    removeFreightContents(containerIdx: number, freightContentIdx: number) {
      (this as any).orderData.containers[containerIdx].freightContents.splice(freightContentIdx, 1);
    },
    addFreightContents(containerIdx: number) {
      // Add first container if needed
      if ((this as any).orderData.containers.length === 0) {
        (this as any).orderData.containers.push({
          containerId: undefined,
          size: undefined,
          type: undefined,
          sealNumber: undefined,
          isAdded: true,
          loadType: 'FullOut',
          freightContents: [],
        });
      }

      (this as any).orderData.containers[containerIdx].freightContents.push({
        quantity: undefined,
        packingType: undefined,
        isHazmat: false,
        weight: undefined,
        description: undefined,
        nmfcNumber: undefined,
        nmfcClass: undefined,
      });
    },
  },
});
</script>
